export default __webpack_public_path__ + "static/media/Google.c10671b3.svg";